import { GET } from './api'

export const ANALYTICS_SECTIONS = [
  'overview',
  'activity',
  'learning',
  'videos',
  'files',
  'users',
  'certificates',
  'surveys',
  'competitive',
  'invitations',
]

export const ANALYTICS_API_SECTIONS = [
  ...ANALYTICS_SECTIONS,
  'onboarding',
  'certificates',
]

const QUERY_KEYS = [
  'period',
  'from',
  'to',
  'persona',
  'course',
  'category',
  'contentType',
  'locale',
  'program',
  'trainer',
  'survey',
  'area',
  'competitiveSection',
  'competitor',
  'source',
  'assistant',
  'search',
  'event',
  'user',
  'content',
  'page',
  'pageSize',
  'sort',
  'direction',
]

export const buildAnalyticsQuery = (filters = {}) => {
  const query = new URLSearchParams()

  QUERY_KEYS.forEach(key => {
    const value = filters?.[key]
    if (value !== undefined && value !== null && `${value}` !== '') {
      query.set(key, value)
    }
  })

  return query.toString()
}

export const ReadAnalyticsAccess = () => GET('/analytics/v1/access', true)

export const ReadAnalyticsFilters = (filters = {}) => {
  const query = buildAnalyticsQuery(filters)
  return GET(`/analytics/v1/filters${query ? `?${query}` : ''}`, true)
}

export const ReadAnalyticsSection = (section = 'overview', filters = {}) => {
  const safeSection = ANALYTICS_API_SECTIONS.includes(section) ? section : 'overview'
  const query = buildAnalyticsQuery(filters)
  return GET(`/analytics/v1/${safeSection}${query ? `?${query}` : ''}`, true)
}

export const ReadAnalyticsDashboard = (days = 30) => (
  ReadAnalyticsSection('overview', { period: `${days}d` })
)
